(() => {
  'use strict';
  const variants = new Set([57896904819020,57896907997516,57896917958988,57896900165964,57896885518668,57896892596556]);
  const knife = 59105735541068, ebook = 56166983434572;
  const codes = ['HOME-COUTEAU-FR-261007','HOME-ELECTRICITE-FR-261007'];
  const root = window.Shopify?.routes?.root || '/';
  const request = window.fetch.bind(window);
  let busy = false, chain = Promise.resolve();
  const api = async (path, body) => {
    const response = await request(root + path, body === undefined ? {headers:{Accept:'application/json'}} : {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)});
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Impossible de mettre à jour le panier.');
    return data;
  };
  async function reconcile() {
    let cart = await api('cart.js');
    const rolls = cart.items.filter(item => variants.has(item.variant_id));
    const eligible = rolls.some(item => item.quantity > 0);
    const setIds = new Set(rolls.map(item => item.properties?._bn_set_id).filter(Boolean));
    const boxes = rolls.filter(item => item.properties?._bn_box_offer === 'home-fr');
    const count = boxes.reduce((sum,item) => sum + item.quantity,0);
    const gifts = cart.items.filter(item => item.properties?._bn_box_gift === 'home-fr');
    const knives = cart.items.filter(item => item.variant_id === knife && (item.properties?._bn_box_gift === 'home-fr' || item.properties?._bn_set_id));
    const kept = knives.find(item => setIds.has(item.properties?._bn_set_id)) || knives[0];
    const hasSetEbook = cart.items.some(item => item.variant_id === ebook && item.properties?._bn_set_id);
    const updates = {}, additions = [];
    for (const item of knives) {
      const wanted = eligible && item === kept ? 1 : 0;
      if (item.quantity !== wanted) updates[item.key] = wanted;
    }
    if (!kept && eligible) additions.push({id:knife,quantity:1,properties:{_bn_box_gift:'home-fr',Cadeau:'Un couteau offert par commande contenant des rouleaux isolants Armaflex'}});
    const ebookQuantity = count && !hasSetEbook ? 1 : 0;
    const ebooks = gifts.filter(item => item.variant_id === ebook);
    if (ebooks.length) {
      if (ebooks[0].quantity !== ebookQuantity) updates[ebooks[0].key] = ebookQuantity;
      ebooks.slice(1).forEach(item => {updates[item.key] = 0;});
    } else if (ebookQuantity) additions.push({id:ebook,quantity:1,properties:{_bn_box_gift:'home-fr',Cadeau:'Guide Électricité Off-Grid offert'}});
    let changed = false;
    if (Object.keys(updates).length) {cart = await api('cart/update.js',{updates});changed = true;}
    if (additions.length) {await api('cart/add.js',{items:additions});cart = await api('cart.js');changed = true;}
    const otherCodes = (cart.discount_codes || []).map(discount => discount.code).filter(code => !codes.includes(code.toUpperCase()));
    const currentCodes = (cart.discount_codes || []).map(discount => discount.code.toUpperCase());
    if (otherCodes.join(',').toUpperCase() !== currentCodes.join(',')) {cart = await api('cart/update.js',{discount:otherCodes.join(',')});changed = true;}
    const managedKnife = cart.items.find(item => item.variant_id === knife && (item.properties?._bn_box_gift === 'home-fr' || item.properties?._bn_set_id));
    if (managedKnife && managedKnife.properties?.Cadeau !== 'Un couteau offert par commande contenant des rouleaux isolants Armaflex') {
      cart = await api('cart/change.js',{id:managedKnife.key,quantity:managedKnife.quantity,properties:{...managedKnife.properties,Cadeau:'Un couteau offert par commande contenant des rouleaux isolants Armaflex'}});changed = true;
    }
    return {cart,changed};
  }
  function enqueue() {const next = chain.catch(() => {}).then(reconcile);chain = next;return next;}
  window.BNHomeBoxGifts = {reconcile:enqueue};
  window.fetch = async function(input,init) {
    const response = await request(input,init);
    const url = typeof input === 'string' ? input : input?.url || '';
    if (/\/cart\/(change|update|add)(\.js)?(?:\?|$)/.test(url)) {
      const outcome = await enqueue();
      if (outcome.changed && location.pathname.replace(/\/$/,'') === root.replace(/\/$/,'') + '/cart') setTimeout(() => location.reload(),150);
    }
    return response;
  };
  document.addEventListener('click',event => {
    const button = event.target.closest('[data-bn-quantity]');
    if (!button) return;
    const input = button.closest('form').querySelector('[name="quantity"]');
    input.value = Math.max(1,(parseInt(input.value,10)||1) + Number(button.dataset.bnQuantity));
  });
  document.addEventListener('submit',async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.action.includes('/cart/add')) return;
    const data = new FormData(form), id = Number(data.get('id'));
    if (!variants.has(id)) return;
    event.preventDefault();event.stopImmediatePropagation();
    if (busy) return;
    busy = true;
    const quantity = Math.max(1,parseInt(data.get('quantity'),10)||1);
    const button = form.querySelector('[type="submit"]');
    const label = button?.innerHTML;
    const error = form.querySelector('[data-bn-box-error]') || form.closest('product-form')?.querySelector('.product-form__error-message');
    if (button) {button.disabled = true;button.textContent = 'Ajout en cours…';}
    if (error) {error.hidden = true;error.closest('.product-form__error-message-wrapper')?.setAttribute('hidden','');}
    try {
      await api('cart/add.js',{items:[{id,quantity,properties:{_bn_box_offer:'home-fr'}}]});
      const outcome = await enqueue();
      const giftLines = outcome.cart.items.filter(item => item.properties?._bn_box_gift === 'home-fr');
      if (giftLines.some(item => item.final_line_price !== 0)) throw new Error('Les cadeaux ont été ajoutés mais leur remise n’a pas été appliquée. Contacte-nous avant de finaliser ta commande.');
      location.href = root + 'cart';
    } catch (exception) {
      if (error) {error.textContent = exception.message;error.hidden = false;error.closest('.product-form__error-message-wrapper')?.removeAttribute('hidden');}
      else alert(exception.message);
      if (button) {button.disabled = false;button.innerHTML = label;}
      busy = false;
    }
  },true);
  if (location.pathname.replace(/\/$/,'') === root.replace(/\/$/,'') + '/cart') enqueue().then(outcome => {if(outcome.changed) location.reload();}).catch(error => console.error('Cadeaux Armaflex HOME :',error.message));
})();
